/**
 * useTour - Consumer hook for feature tour
 *
 * Usage:
 *   import { useTour } from '../tour';
 *
 *   function MyComponent() {
 *     const { startTour, isActive } = useTour();
 *
 *     return (
 *       <button onClick={() => startTour('main')}>
 *         Start Tour
 *       </button>
 *     );
 *   }
 */

import { useContext } from 'react';
import { TourContext } from './TourProvider.jsx';

export function useTour() {
  const context = useContext(TourContext);

  if (!context) {
    throw new Error('useTour must be used within a TourProvider');
  }

  return context;
}

export default useTour;
